"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EU_COUNTRIES = void 0;
// The list of EU (and EEA / EFTA) country codes.
// NOTE(sumin): http://ec.europa.eu/eurostat/statistics-explained/index.php/Tutorial:Country_codes_and_protocol_order
//              The two-letter ISO code is used (ISO 3166 alpha-2) except for Greece and the United Kingdom,
//              for which the abbreviations EL and UK have to be used. These are added to the end as a safeguard not
//              to be confused with what geoip uses (GR and GB).
exports.EU_COUNTRIES = [
    'AT',
    'BE',
    'BG',
    'CH',
    'CY',
    'CZ',
    'DE',
    'DK',
    'EE',
    'ES',
    'FI',
    'FR',
    'GB',
    'GR',
    'HR',
    'HU',
    'IE',
    'IS',
    'IT',
    'LI',
    'LT',
    'LU',
    'LV',
    'MT',
    'NL',
    'NO',
    'PL',
    'PT',
    'RO',
    'SE',
    'SI',
    'SK',
    'EL',
    'UK',
];
//# sourceMappingURL=countries.js.map